function* IdGenerator() {
  let id = 0
  while (true) yield id++
}

export const generateId = IdGenerator()
